import React, { useState, useEffect } from "react";
import Header from "../Header";
import { ClassicSpinner } from "react-spinners-kit";
import { useNavigate } from "react-router-dom";
import {
  FetchAllCourses,
  FetchMentorDetails,
  AssignCourseToMentor,
} from "../../api/aws-api";
import { ConstructorEventGet, ConstructorEventPost } from "../../Event/event";
import { notifySuccess, notifyError } from "../../Common/CommonFunction";

const AssigningCourseToMentor = () => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [mentors, setMentors] = useState([]);

  const [selectedMentor, setSelectedMentor] = useState("");
  const [selectedCourse, setSelectedCourse] = useState([]); // ✅ always array

  useEffect(() => {
    fetchCourses();
    fetchMentorDetails();
  }, []);

  /* ---------------- API CALLS ---------------- */

  const fetchCourses = async () => {
    setLoading(true);
    try {
      const response = await ConstructorEventGet(FetchAllCourses);
      setCourses(response || []);
    } catch (error) {
      notifyError("Failed to fetch courses");
    }
    setLoading(false);
  };

  const fetchMentorDetails = async () => {
    try {
      const response = await ConstructorEventGet(FetchMentorDetails);
      setMentors(response || []);
    } catch (error) {
      notifyError("Failed to fetch mentors");
    }
  };

  /* ---------------- HANDLERS ---------------- */

  const selectMentor = (mentorId) => {
    setSelectedMentor(mentorId);

    const mentor = mentors.find((m) => m.user_id === mentorId);

    // ✅ guarantee array
    setSelectedCourse(Array.isArray(mentor?.course) ? mentor.course : []);
  };

  const selectCourse = (course_id, course_name, event) => {
    const { checked } = event.target;

    setSelectedCourse((prev) =>
      checked
        ? [...prev, { course_id, course_name }]
        : prev.filter((c) => c.course_id !== course_id)
    );
  };

  const assignCourseToMentor = async () => {
    if (!selectedMentor) {
      notifyError("Please select a mentor");
      return;
    }

    setLoading(true);

    const params = {
      UserId: selectedMentor,
      Courses: selectedCourse,
    };

    const response = await ConstructorEventPost(
      AssignCourseToMentor,
      params
    );

    // if (response?.statusCode === 200) {
    //   notifySuccess("Course assigned to mentor successfully");
    //   setSelectedMentor("");
    //   setSelectedCourse([]);
    //   navigate(0);
    // } else {
    //   notifyError("Error while assigning course to mentor");
    // }

    if (response?.statusCode === 200) {
      notifySuccess("Course assigned to mentor successfully");
      setSelectedMentor("");
      setSelectedCourse([]);
      fetchMentorDetails(); // refreshes mentor data without touching navigation/history at all
    } else {
      notifyError("Error while assigning course to mentor");
    }

    setLoading(false);
  };

  /* ---------------- UI ---------------- */

  return (
    <>
      <Header />

      {loading ? (
        <div className="spinner">
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={loading} />
          </div>
        </div>
      ) : (
        <div className="nav-tab-wrapper tabs section-padding">
          <div className="container">
            <div className="mini-title">Assign Course To Mentor</div>

            <div className="grid grid-cols-12 gap-[30px]">
              {/* -------- COURSES -------- */}
              <div className="xl:col-span-6 lg:col-span-6 col-span-12">
                <div className="bg-white shadow-box7 p-8 rounded-md mt-8">
                  <div className="text-center">
                    <b>Courses</b>
                  </div>

                  {courses.map((course) => (
                    <p
                      key={course.course_id}
                      className="shadow-sm p-4 bg-body-tertiary rounded"
                    >
                      <input
                        type="checkbox"
                        checked={selectedCourse.some(
                          (c) => c.course_id === course.course_id
                        )}
                        onChange={(e) =>
                          selectCourse(
                            course.course_id,
                            course.course_name,
                            e
                          )
                        }
                      />{" "}
                      {course.course_name}
                    </p>
                  ))}
                </div>
              </div>

              {/* -------- MENTORS -------- */}
              <div className="xl:col-span-6 lg:col-span-6 col-span-12 mt-8">
                <div className="bg-white shadow-box7 p-8 rounded-md">
                  <div className="text-center">
                    <b>Mentors</b>
                  </div>

                  {mentors.map((mentor) => (
                    <p
                      key={mentor.user_id}
                      className="shadow-sm p-4 bg-body-tertiary rounded"
                    >
                      <input
                        type="radio"
                        name="mentor"
                        checked={selectedMentor === mentor.user_id}
                        onChange={() => selectMentor(mentor.user_id)}
                      />{" "}
                      {mentor.user_name}
                    </p>
                  ))}
                </div>
              </div>
            </div>

            <div className="text-center mt-6">
              <button
                className="btn btn-primary"
                onClick={assignCourseToMentor}
              >
                Assign Courses To The Mentor
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AssigningCourseToMentor;